/** 起動時に読む接続先(API が環境変数から生成する)。ビルドに焼き込まない。 */
export type RuntimeConfig = {
  apiBase: string;
  keycloakUrl: string;
  realm: string;
  clientId: string;
};

export async function loadConfig(): Promise<RuntimeConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`/config.json を読めない (HTTP ${res.status})`);
  return (await res.json()) as RuntimeConfig;
}
